const Footer: React.FC<{ isFullWidth?: boolean }> = ({
  isFullWidth = false,
}) => {
  return (
    // <!-- Footer -->
    <footer className="footer">
      <div className="footer-content">
        {/* <div className="footer-links">
          <a href="# ">About</a>
          <a href="# ">Privacy Policy</a>
          <a href="# ">Terms of Service</a>
          <a href="# ">Contact</a>
        </div> */}
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} <a href="# ">Work Order Direct</a>.
          All Rights Reserved.
        </div>
        <div className="footer-credits"></div>
      </div>
    </footer>
  );
};

export default Footer;
